import { ComponentType, LazyExoticComponent, lazy } from 'react'
import Swal from 'sweetalert2'
export * from './imported-component-retry'

type LazyWithRetryType = <T extends ComponentType<any>>(
	fn: () => Promise<{ default: T }>
) => LazyExoticComponent<T>

export const lazyWithRetry: LazyWithRetryType = componentImport =>
	lazy(async () => {
		try {
			const component = await componentImport()

			return component
		} catch (error) {
			const pageHasAlreadyBeenForceRefreshed = JSON.parse(
				window.localStorage.getItem('page-has-been-force-refreshed') || 'false'
			)

			if (!pageHasAlreadyBeenForceRefreshed) {
				// Assuming that the user is not on the latest version of the application.
				// Let's refresh the page immediately.
				window.localStorage.setItem('page-has-been-force-refreshed', 'true')
				Swal.fire({
					type: 'info',
					title: 'Обновление',
					text: `Приложение устарело. Требуется обновление!`,
					showCancelButton: false,
					showConfirmButton: true,
					confirmButtonText: 'Обновить',
				}).then(result => {
					if (result.value) {
						window.localStorage.setItem(
							'page-has-been-force-refreshed',
							'false'
						)
						window.location.reload()
					}
				})

				return null
			}

			// The page has already been reloaded
			// Assuming that user is already using the latest version of the application.
			// Let's let the application crash and raise the error.
			throw error
		}
	})
